import React from 'react';
import { componentService } from 'js/services/component.service';

export const AutomaticWithdrawLimit = React.lazy(() => import(/* webpackChunkName: "automatic-withdraw-limit" */ './AutomaticWithdrawLimit'));

// <hub2-automatic-withdraw-limit></hub2-automatic-withdraw-limit>
componentService.registerWebContentComponents({ AutomaticWithdrawLimit });
